import { useCallback } from 'react';

import type { CustomFilterProps } from 'ag-grid-react';
import { useGridFilter } from 'ag-grid-react';

import { useFeatureFlag } from '@/app/services/features';
import { Switch } from '@/components/ui/switch';

export function BooleanToggleFilter({
  model,
  onModelChange,
  colDef,
}: CustomFilterProps) {
  const preserveGridState = useFeatureFlag('Shipping_Preserve_Grid_State');

  const checked =
    model?.filterType === 'set' &&
    Array.isArray(model.values) &&
    (model.values[0] === true ||
      (preserveGridState && model.values[0] === 'true'));

  // required by AG Grid to track the filter state
  const doesFilterPass = useCallback(() => true, []);
  useGridFilter({ doesFilterPass });

  return (
    <label className="flex cursor-pointer items-center gap-2 p-2 text-sm">
      <Switch
        size="sm"
        checked={checked}
        onCheckedChange={(val) => {
          onModelChange(val ? { filterType: 'set', values: [true] } : null);
        }}
      />
      {colDef.headerName}
    </label>
  );
}
